const mantineRandomColor = () => {
  const colors = ["dark", "red", "orange", "grape", "indigo", "cyan", "yellow", "green", "teal", "blue", "lime", "violet", "pink"];
  return colors[Math.floor(Math.random() * colors.length)];
};

export default mantineRandomColor;
